import { useAppSelector } from "../../../../../redux/hooks"
import { KTIcon } from "../../../../../_metronic/helpers"
import { useEffect, useState } from 'react'
import { getCTXConnectorstatus, getCTXConnectorstatusGlobal } from "../requests/request"
import Spinnerabsolute from "../../Spinner/Spinnerabsolute"
import { useAuth } from "../../../auth"

type x = {
  connector: string,
  instance: string,
  status: string,
  subscription: string
}

export default function StatusConnector(props: any) {
  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  const Type = useAppSelector(state => state.CloudSlice.Type)
  const tenant = useAppSelector(state => state.TenantSlice.id)
  const nameregion = useAppSelector(state => state.RegionSlice.name)
  const FlagReg = useAppSelector(state => state.FlagSlice.value)
  const { currentUser } = useAuth()

  const [Loading, setLoading] = useState(false)
  const [statusConnector, setstatusConnector] = useState<x[]>([])

  useEffect(() => {
    setLoading(true)
    const abortController = new AbortController()
    const signal = abortController.signal

    //if (FlagReg === true) {
      const fetchData = async () => {
        try {
          //setLoading(true) 
          let response
          if (currentUser?.ListPermiso?.includes('Home.Status') && Type !== 'CloudGlobal' && props.id === 1 && tenant === 0) {
            response = await getCTXConnectorstatus(Id, signal, Type, nameregion)
          } else if (currentUser?.ListPermiso?.includes('Home.Status') && Type !== 'CloudGlobal' && props.id === 1 && tenant !== 0) {
            response = await getCTXConnectorstatusGlobal(Id, tenant, signal, Type, nameregion)
          } else if (currentUser?.ListPermiso?.includes('Home.Status') && Type === 'CloudGlobal' && props.id === 1 && tenant === 0) {
            response = await getCTXConnectorstatus(Id, signal)
          } else if (currentUser?.ListPermiso?.includes('Home.Status') && Type === 'CloudGlobal' && props.id === 1 && tenant !== 0) {
            response = await getCTXConnectorstatusGlobal(Id, tenant, signal)
          }

          if (!signal.aborted) {
            setstatusConnector(response?.data || [])
          }
        } catch (error) {
          console.error('Error fetching data:', error)
        } finally {
          setLoading(false) // Siempre desactiva el loading después de intentar la petición
        }
      }
      fetchData()
    /*} else {
      setLoading(false) // Asegura desactivar loading si FlagReg no es verdadero
    }*/

    return () => {
      abortController.abort()
    }
  }, [props.id, nameregion, FlagReg])

  useEffect(() => {
    setLoading(true)
    const abortController = new AbortController()
    const signal = abortController.signal

    if (Id && (Type !== '' || Type !== null)) {
      const fetchData = async () => {
        try {
          let response
          if (currentUser?.ListPermiso?.includes('Home.Status') && tenant === 0 && props.id === 1) {
            response = await getCTXConnectorstatus(Id, signal)
          } else if (currentUser?.ListPermiso?.includes('Home.Status') && tenant !== 0 && props.id === 1) {
            response = await getCTXConnectorstatusGlobal(Id, tenant, signal)
          }

          if (!signal.aborted) {
            setstatusConnector(response?.data || [])
          }
        } catch (error) {
          console.error('Error fetching data:', error)
        } finally {
          setLoading(false) // Siempre desactiva el loading
        }
      }
      fetchData()
    } else {
      setLoading(false) // Asegura desactivar loading si Id no cumple la condición
    }

    return () => {
      abortController.abort()
    }
  }, [Id, Type])

  useEffect(() => {
    if (nameregion) {
      setstatusConnector([])
    }
  }, [nameregion])

  return (
    <>
      <div className="card card-custom border border-gray-300 ">
        {currentUser?.ListPermiso?.includes('Home.Status') && Id !== 0 && Loading && <Spinnerabsolute />}
        {currentUser?.ListPermiso?.includes('Home.Status') && Type === 'CloudGlobal' && Loading && <Spinnerabsolute />}
        <div>
          <br />
          <div className='text-marino f-titulo fs-md text-center' style={{ marginBottom: '8px' }}> CONNECTOR STATUS</div>
        </div>
        <div className="border shadow-sm rounded-lg menu-scroll">
          <div className="relative w-full overflow-auto">
            <div className="card-body card-scroll table-container h-250px">
              {statusConnector.length === 0 ? (
                <div className="no-data-message">No Data Available</div>
              ) : (
                <table className="w-full f-parrafo caption-bottom custom-table">
                  <thead className='table-header-light bg-marino table-header-fixed'>
                    <tr>
                      <th className="table-cell">CTX Connector</th>
                      {Id !== 0 && Type !== 'CloudGlobal' && <th className="table-cell">Instance</th>}
                      {Id === -1 && Type === 'CloudGlobal' && <th className="table-cell">Subscription</th>}
                      <th className="table-cell">Description</th>
                      <th className="table-cell">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {statusConnector.map((d, i) => (
                      <tr key={i} className="table-row">
                        {Id !== 0 && d?.connector?.includes(Type) && <td className="table-cell">{d?.connector}</td>}
                        {Type === 'CloudGlobal' && <td className="table-cell">{d?.connector}</td>}
                        {Id !== 0 && d?.connector?.includes(Type) && <td className="table-cell">{d?.instance}</td>}
                        {Id === -1 && Type === 'CloudGlobal' && <td className="table-cell">{d?.subscription}</td>}
                        {Id !== 0 && d?.connector?.includes(Type) && d?.connector?.includes('CPR') && <td className="table-cell">Cloud Peering</td>}
                        {Id !== 0 && d?.connector?.includes(Type) && d?.connector?.includes('VPN') && <td className="table-cell">VPN Peering</td>}
                        {Id !== 0 && d?.connector?.includes(Type) && d?.connector?.includes('EDG') && <td className="table-cell">Edge Peering</td>}
                        {Type === 'CloudGlobal' && d?.connector?.includes('CPR') && <td className="table-cell">Cloud Peering</td>}
                        {Type === 'CloudGlobal' && d?.connector?.includes('VPN') && <td className="table-cell">VPN Peering</td>}
                        {Type === 'CloudGlobal' && d?.connector?.includes('EDG') && <td className="table-cell">Edge Peering</td>}
                        {Id !== 0 && d?.status === "UP" && d?.connector?.includes(Type) && <td className="table-cell"><KTIcon iconName='bi bi-check-circle' className='text-success fs-1' /></td>}
                        {Type === 'CloudGlobal' && d?.status === "UP" && <td className="table-cell"><KTIcon iconName='bi bi-check-circle' className='text-success fs-1' /></td>}
                        {Id !== 0 && d?.status === "DOWN" && d?.connector?.includes(Type) && <td className="table-cell"><KTIcon iconName='bi bi-x-circle' className='text-danger fs-1' /></td>}
                        {Type === 'CloudGlobal' && d?.status === "DOWN" && <td className="table-cell"><KTIcon iconName='bi bi-x-circle' className='text-danger fs-1' /></td>}
                        {Id !== 0 && d?.status === "UNKNOWN" && d?.connector?.includes(Type) && <td className="table-cell"><KTIcon iconName='bi bi-exclamation-triangle' className='text-warning fs-1' /></td>}
                        {Type === 'CloudGlobal' && d?.status === "UNKNOWN" && <td className="table-cell"><KTIcon iconName='bi bi-exclamation-triangle' className='text-warning fs-1' /></td>}
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
              {Id === 0 && Type !== 'Global' && (
                <table className="table table-striped gy-7 gs-7">
                  <tbody>
                    <tr>
                      <td className="text-center">Select a Cloud with available subscriptions</td>
                    </tr>
                  </tbody>
                </table>
              )}
            </div>
            <div className="card-footer"></div>
          </div>
        </div>
      </div>
    </>
  )
}
